import { render, staticRenderFns } from "./example-point-history.vue?vue&type=template&id=4da61421"
import script from "./example-point-history.vue?vue&type=script&lang=js"
export * from "./example-point-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports